import requests from "./httpService";

const LeadSettingsService = {
    getLeadSettings(companyId) {
        return requests.get(`/lead-settings/all?company_id=${companyId}`);
    },
    createLeadSetting(body) {
        return requests.post(`/lead-settings/create`, body);
    },
    updateLeadSetting(id, body) {
        return requests.post(`/lead-settings/update/${id}`, body);
    },
    updateStatus(id) {
        return requests.post(`/lead-settings/statusupdate/${id}`);
    },
};

export default LeadSettingsService;
